import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../providers/AuthContext";

export default function EditProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [photos, setPhotos] = useState([]);
  const [photos_server, setPhotos_server] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const { user } = useAuth();

  const [managerData, setManagerData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}managers?status=active`, {credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setManagerData(data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  // Fetch profile details
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}profiles/${id}`, {credentials: "include"})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // delete data.data.manager_name;
          data.data.manager = data.data.manager._id;
          data.data.dob=data.data.dob.split('T')[0];
          setFormData(data.data);
          setPhotos_server(data.data.photos);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const totalFiles = photos.length + files.length + photos_server.length;

    if (totalFiles > 3) {
      alert("You can upload a maximum of 3 photos.");
      // const allowedFiles = files.slice(0, 3 - photos.length);
      // setPhotos([...photos, ...allowedFiles]);
    } else {
      setPhotos([...photos, ...files]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const files = Array.from(e.dataTransfer.files);
      const totalFiles = photos.length + files.length + photos_server.length;

      if (totalFiles > 3) {
        alert("You can upload a maximum of 3 photos.");
        // const allowedFiles = files.slice(0, 3 - photos.length);
        // setPhotos([...photos, ...allowedFiles]);
      } else {
        setPhotos([...photos, ...files]);
      }
    }
  };

  const removePhoto = (index) => {
    setPhotos(photos.filter((_, i) => i !== index));
  };

  const handleDeletePhoto = (photoId) => {
    if (window.confirm("Delete this photo?")) {
      fetch(`${process.env.REACT_APP_API_URL}deletePhotos/${photoId}`, {
        method: "DELETE",
        credentials: "include"
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data.message);
          setPhotos_server(photos_server.filter((p) => p._id !== photoId));
        });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    for (const key in formData) {
      if (formData[key] !== "photos") {
        data.append(key, formData[key]);
      }
    }

    photos.forEach((file) => {
      data.append("photos", file);
    });

    console.log(formData);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}profiles/${id}`,
        {
          method: "PUT",
          credentials: "include",
          body: data,
        }
      );

      const result = await response.json();
      console.log(result);
      alert(result.message || "Profile submitted!");
      navigate(process.env.PUBLIC_URL + "/profile/" + id);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <Link
        to={`${process.env.PUBLIC_URL}/profile/${id}`}
        className="btn btn-secondary mb-3"
      >
        ← Back to Profiles
      </Link>
      <div className="card shadow-lg p-4">
        <h2 className="text-center p-3">Edit Profile</h2>
        <form onSubmit={handleSubmit}>
          {user.role === "admin" && (
            <>
              <h4 className="mb-3">Manager Details</h4>
              <div className="row g-3 b-3 mb-3">
                <div className="col-md-6">
                  <label className="form-label">Select Manager</label>
                  <select
                    className="form-select form-control"
                    name="manager"
                    onChange={handleChange}
                    value={formData.manager || ""}
                  >
                    <option value="">Select</option>
                    {managerData.length > 0 &&
                      managerData.map((manager, index) => (
                        <option value={manager._id} key={index}>
                          {manager.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </>
          )}
          {/* Personal Details */}
          <h4 className="mb-3">Personal Details</h4>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Name with surname</label>
              <input
                className="form-control"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                value={formData.dob || ""}
                onChange={handleChange}
              />
            </div>
            {/* <div className="col-md-6">
              <label className="form-label">Age</label>
              <input
                type="number"
                className="form-control"
                name="age"
                value={formData.age || ""}
                onChange={handleChange}
              />
            </div> */}
            <div className="col-md-6">
              <label className="form-label">Gender</label>
              <select
                name="gender"
                className="form-control"
                required
                value={formData.gender || ""}
                onChange={handleChange}
              >
                <option value="">-- Select Gender --</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Birth Nakshatram</label>
              <select
                name="nakshatram"
                className="form-control"
                required
                value={formData.nakshatram || ""}
                onChange={handleChange}
              >
                <option value="">-- Select Nakshatra --</option>
                <option value="Ashwini">Ashwini</option>
                <option value="Bharani">Bharani</option>
                <option value="Krittika">Krittika</option>
                <option value="Rohini">Rohini</option>
                <option value="Mrigashira">Mrigashira</option>
                <option value="Ardra">Ardra</option>
                <option value="Punarvasu">Punarvasu</option>
                <option value="Pushya">Pushya</option>
                <option value="Ashlesha">Ashlesha</option>
                <option value="Magha">Magha</option>
                <option value="Purva Phalguni">Purva Phalguni</option>
                <option value="Uttara Phalguni">Uttara Phalguni</option>
                <option value="Hasta">Hasta</option>
                <option value="Chitra">Chitra</option>
                <option value="Swati">Swati</option>
                <option value="Vishakha">Vishakha</option>
                <option value="Anuradha">Anuradha</option>
                <option value="Jyeshtha">Jyeshtha</option>
                <option value="Mula">Mula</option>
                <option value="Purva Ashadha">Purva Ashadha</option>
                <option value="Uttara Ashadha">Uttara Ashadha</option>
                <option value="Shravana">Shravana</option>
                <option value="Dhanishta">Dhanishta</option>
                <option value="Shatabhisha">Shatabhisha</option>
                <option value="Purva Bhadrapada">Purva Bhadrapada</option>
                <option value="Uttara Bhadrapada">Uttara Bhadrapada</option>
                <option value="Revati">Revati</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Padam</label>
              <select
                name="padam"
                className="form-control"
                value={formData.padam || ""}
                required
                onChange={handleChange}
              >
                <option value="">-- Select Padam --</option>
                <option value="1st Padam">1st Padam</option>
                <option value="2nd Padam">2nd Padam</option>
                <option value="3rd Padam">3rd Padam</option>
                <option value="4th Padam">4th Padam</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Birth Rasi</label>
              <select
                name="rasi"
                className="form-control"
                required
                value={formData.rasi || ""}
                onChange={handleChange}
              >
                <option value="">-- Select Rasi --</option>
                <option value="Mesha">Mesha</option>
                <option value="Vrishabha">Vrishabha</option>
                <option value="Mithuna">Mithuna</option>
                <option value="Karkataka">Karkataka</option>
                <option value="Simha">Simha</option>
                <option value="Kanya">Kanya</option>
                <option value="Tula">Tula</option>
                <option value="Vrishchika">Vrishchika</option>
                <option value="Dhanu">Dhanu</option>
                <option value="Makara">Makara</option>
                <option value="Kumbha">Kumbha</option>
                <option value="Meena">Meena</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Time of Birth</label>
              <input
                type="time"
                className="form-control"
                name="tob"
                value={formData.tob || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Place of Birth</label>
              <input
                className="form-control"
                name="pob"
                value={formData.pob || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Height (in feet)</label>
              <input
                className="form-control"
                name="height"
                value={formData.height || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Complexion</label>
              <select
                className="form-select form-control"
                name="complexion"
                value={formData.complexion || ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Fair">Fair</option>
                <option value="Medium">Medium</option>
                <option value="Dark">Dark</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Education</label>
              <input
                className="form-control"
                name="education"
                value={formData.education || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">College Studied</label>
              <input
                className="form-control"
                name="college"
                value={formData.college || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Job</label>
              <select
                className="form-select form-control"
                name="jobType"
                value={formData.jobType || ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Software">Software</option>
                <option value="Bank">Bank</option>
                <option value="Govt. Job">Govt. Job</option>
                <option value="Private Corporate">Private Corporate</option>
                <option value="Doctor">Doctor</option>
                <option value="Others">Others</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Job Role</label>
              <input
                className="form-control"
                name="jobRole"
                value={formData.jobRole || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Company Name</label>
              <input
                className="form-control"
                name="company"
                value={formData.company || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Salary per annum(LPA)</label>
              <input
                type="number"
                className="form-control"
                name="salary"
                max={100}
                step={0.01}
                value={formData.salary || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Place of Work</label>
              <input
                className="form-control"
                name="workPlace"
                value={formData.workPlace || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Wanted partner from any specific field?
              </label>
              <input
                className="form-control"
                name="partnerPreference"
                value={formData.partnerPreference || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Family Details */}
          <h4 className="mt-5 mb-3">Family Details</h4>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Father Name</label>
              <input
                className="form-control"
                name="fatherName"
                value={formData.fatherName || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Father Job</label>
              <input
                className="form-control"
                name="fatherJob"
                value={formData.fatherJob || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Mother Name</label>
              <input
                className="form-control"
                name="motherName"
                value={formData.motherName || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Mother Job</label>
              <input
                className="form-control"
                name="motherJob"
                value={formData.motherJob || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 1</label>
              <input
                className="form-control"
                name="sibling1"
                value={formData.sibling1 || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Sibling 1 Job</label>
              <input
                className="form-control"
                name="siblingJob1"
                value={formData.siblingJob1 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 2</label>
              <input
                className="form-control"
                name="sibling2"
                value={formData.sibling2 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 2 Job</label>
              <input
                className="form-control"
                name="siblingJob2"
                value={formData.siblingJob2 || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Sibling 3</label>
              <input
                className="form-control"
                name="sibling3"
                value={formData.sibling3 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 3 Job</label>
              <input
                className="form-control"
                name="siblingJob3"
                value={formData.siblingJob3 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 4</label>
              <input
                className="form-control"
                name="sibling4"
                value={formData.sibling4 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sibling 4 Job</label>
              <input
                className="form-control"
                name="siblingJob4"
                value={formData.siblingJob4 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Caste</label>
              <input
                className="form-control"
                name="caste"
                value={formData.caste || "Velama"}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Sub Caste</label>
              <select
                name="subCaste"
                className="form-control"
                required
                value={formData.subCaste || ""}
                onChange={handleChange}
              >
                <option value="">-- Select Sub Caste --</option>
                <option value="Polinati Velama">Polinati Velama</option>
                <option value="Koppula Velama">Koppula Velama</option>
                <option value="Adi Velama">Adi Velama</option>
                <option value="Padmanayaka Velama">Padmanayaka Velama</option>
                <option value="Other Velama">Other Velama</option>
              </select>
            </div>
            <div className="col-md-12">
              <label className="form-label">Present Family Address</label>
              <textarea
                className="form-control"
                name="address"
                value={formData.address || ""}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="col-md-6">
              <label className="form-label">Native Place</label>
              <input
                className="form-control"
                name="nativePlace"
                value={formData.nativePlace || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Contact Numbers</label>
              <input
                className="form-control"
                name="contact"
                minLength="10"
                maxLength={10}
                value={formData.contact || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Photo Upload */}
          <h4 className="mt-5 mb-3">Upload Photos</h4>
          <div className="row g-3 mb-3">
            {photos_server.length > 0 &&
              photos_server.map((photo, index) => (
                <div className="col-md-3 position-relative" key={index}>
                  <img
                    src={`${process.env.REACT_APP_SERVER_DOMAIN}${photo.photo_path}`}
                    alt="Profile"
                    className="img-thumbnail"
                    style={{
                      width: "100%",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-danger position-absolute top-0 end-0"
                    onClick={() => handleDeletePhoto(photo._id)}
                  >
                    ×
                  </button>
                </div>
              ))}
          </div>
          <div
            className={`border border-2 p-4 text-center rounded ${
              dragActive ? "border-primary bg-light" : "border-secondary"
            }`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              className="form-control d-none"
              id="photoUpload"
              disabled={photos.length + photos_server.length >= 3}
            />
            <label
              htmlFor="photoUpload"
              style={{
                cursor:
                  photos.length + photos_server.length >= 3
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {photos.length > 0 ? (
                <div className="row g-3">
                  {photos.map((file, index) => (
                    <div
                      key={index}
                      className="col-md-4 text-center position-relative"
                    >
                      <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 m-1"
                        aria-label="Remove"
                        onClick={() => removePhoto(index)}
                      ></button>
                      <p className="mb-1 small text-truncate" title={file.name}>
                        {file.name}
                      </p>
                      <img
                        src={URL.createObjectURL(file)}
                        alt="preview"
                        className="img-fluid rounded border"
                        style={{ maxHeight: "150px" }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="mb-0">
                  Drag & Drop photos here or click to upload{" "}
                  <small>(Max 3 Photos)</small>
                </p>
              )}
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 mt-4"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
